import { createTheme } from "@mui/material";
import { esES } from "@mui/material/locale";

/**
 * Tema MUI del sitio institucional de Access Informática.
 *
 * Además de la paleta estándar de MUI, expone `theme.custom` con los tokens
 * de diseño (degradados, radios, sombras, tipografías) que consumen los
 * styled-components de `components/styled/*`.
 */
export const themeMui = createTheme(
  {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    palette: {
      primary: {
        light: "#2E6FD6",
        main: "#174F9B",
        dark: "#08306B",
        contrastText: "#FFFFFF",
      },
      secondary: {
        light: "#8AC2EC",
        main: "#4BA3E0",
        dark: "#2E6FD6",
        contrastText: "#06172F",
      },
      success: { main: "#2E9BD9" },
      error: { main: "#d32f2f" },
      text: {
        primary: "#0E2A52",
        secondary: "#4b587a",
      },
      background: {
        default: "#ffffff",
        soft: "#f6f8fc",
      },
    },
    typography: {
      fontFamily: "Inter, system-ui, sans-serif",
      fontFamilyDisplay: "Sora, system-ui, sans-serif",
    },
    // Tokens de diseño propios del sitio
    custom: {
      colors: {
        navy950: "#030B1C",
        navy900: "#06172F",
        navy800: "#0A2247",
        navy700: "#0E2C5C",
        indigo600: "#174F9B",
        indigo500: "#2E6FD6",
        cyan400: "#4BA3E0",
        cyan300: "#8AC2EC",
        teal400: "#2E9BD9",
        violet500: "#2B5CB8",
        slate500: "#5f6c8c",
        slate200: "#dbe2f0",
        textSoft: "#4b587a",
        border: "rgba(20, 32, 58, 0.10)",
      },
      gradient: {
        brand: "linear-gradient(120deg, #4BA3E0 0%, #2E6FD6 55%, #2B5CB8 100%)",
        brandSoft:
          "linear-gradient(120deg, rgba(75,163,224,0.14), rgba(23,79,155,0.14))",
      },
      radius: {
        sm: "10px",
        md: "18px",
        lg: "28px",
        full: "999px",
      },
      shadow: {
        sm: "0 2px 8px rgba(16, 26, 61, 0.06)",
        md: "0 18px 45px -20px rgba(16, 26, 61, 0.28)",
        lg: "0 40px 80px -30px rgba(16, 26, 61, 0.45)",
      },
      fonts: {
        display: "Sora, system-ui, sans-serif",
        body: "Inter, system-ui, sans-serif",
      },
      navHeight: 74,
      container: 1200,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "html, body, #root": {
            margin: 0,
            padding: 0,
            scrollBehavior: "smooth",
          },
          body: {
            fontFamily: "Inter, system-ui, sans-serif",
            color: "#0E2A52",
            backgroundColor: "#ffffff",
            WebkitFontSmoothing: "antialiased",
            overflowX: "hidden",
          },
          "h1, h2, h3, h4": {
            fontFamily: "Sora, system-ui, sans-serif",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            margin: 0,
          },
          "*::-webkit-scrollbar": { width: "0.55em", height: "0.55em" },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#a3c5f4",
            borderRadius: "7px",
          },
          a: { textDecoration: "none", color: "inherit" },
          img: { display: "block", maxWidth: "100%" },
        },
      },
    },
  },
  esES,
);
